export default {
  getHead: () => {
    return [{ name: "회사명" },  { name: "재해유형" }, { name: "점검일" }, { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name; // 회사명
      case 1:
        return func.getContent(value).inputF_3; // 재해유형
      case 2:
        return func.getContent(value).inputA_3; // 점검일
      case 3:
        return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    if (nav.value.disasterType) returnData.push('content$body.inputA_4*[:default_disaster]');

    switch (nav.value.searchType) {
    case "회사명":
      returnData.push("content$body.stdInfo.field_name*%[:default_skw]%");
      break;
    case "소속2":
      returnData.push("content$body.stdInfo.department*%[:default_skw]%");
      break;
    case "소속1":
      returnData.push("content$body.stdInfo.section*%[:default_skw]%");
      break;
    case "재해유형":
      returnData.push("content$body.inputF_3*%[:default_skw]%");
      break;
    case "점검일":
      returnData.push("content$body.inputA_3*%[:default_skw]%");
      break;
    }

    return returnData;
  },
};
